import { GET_DISTANCE_LIST, GET_DISTANCE_LIST_REQUEST, GET_DISTANCE_MATRIX, GET_DISTANCE_MATRIX_REQUEST } from '../constants/action-types';

const initialState = {
  farmId: null,
  isRequesting: false,
  distanceList: [],
  generatedDistanceList: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DISTANCE_LIST_REQUEST:
      state = {
        ...state,
        isRequesting: true,
        distanceList: []
      }
      break;
    case GET_DISTANCE_LIST:
      state = {
        ...state, farmId: action.farmId,
        isRequesting: false,
        distanceList: [...action.payload],
      };
      break;
      case GET_DISTANCE_MATRIX_REQUEST:
      state = {
        ...state,
        isRequesting: true,
        generatedDistanceList: []
      }
      break;
    case GET_DISTANCE_MATRIX:
      state = {
        ...state, farmId: action.farmId,
        isRequesting: false,
        generatedDistanceList: [...action.payload],
      };
      break;
    default:
      break;
  }
  return state;
};